module.exports = __webpack_public_path__ + "static/media/PITTAR.ef9c1020.svg";